import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { DatabaseProvider } from '../../providers/database/database';
import { AuthProvider } from '../../providers/auth/auth';

@IonicPage()
@Component({
  selector: 'admin-supplies-add',
  templateUrl: 'admin-supplies-add.html',
})
export class AdminSuppliesAddPage {

  clinic_name: string;
  clinic_id: string;
  drugtypes: any;
  categories: any;
  supply: any;
  supplydata: any = {};
  supplyForm: FormGroup;
  din: FormControl
  name: FormControl;
  strength: FormControl;
  size: FormControl;
  unit: FormControl;
  category: FormControl;
  sort: FormControl;

  isExisting: boolean = false;
  operation_type: any = 'Add Supplies';

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private viewCtrl: ViewController, 
    public formBuilder: FormBuilder,
    private database: DatabaseProvider,
    private auth: AuthProvider,
    private loadingCtrl: LoadingController) {

    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });

    this.din = new FormControl("", Validators.required);
    this.name = new FormControl("", Validators.required);
    this.strength = new FormControl("");
    this.size = new FormControl("");
    this.unit = new FormControl("");
    this.category = new FormControl("", Validators.required);

    this.supply = formBuilder.group({
      din: this.din,
      name: this.name,
      strength: this.strength,
      size: this.size,
      unit: this.unit,
      category: this.category,
      sort: null
    });

    if (this.navParams.get('supplydata')) {
      const supply: any = this.navParams.get('supplydata');
      this.supply.patchValue(supply);
    
      this.isExisting = true;
      this.operation_type = "Edit " + supply.name;
    }
    this.categories = [{'name':'SYRINGE'},{'name': 'NEEDLE'},{'name': 'DRUG - RX REQUIRED'},{'name': 'DRUG - OTC'},{'name': 'KITS'},{'name': 'COMPOUNDING'},{'name': 'MISC'},{'name': 'No Category'}];
  }

  ionViewDidLoad() {}

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addSupply() {
    console.log(this.clinic_id);
    console.log(this.supply.value);
    const supply: {} = this.supply.value;
    if(supply['sort']) {
      supply['sort'] = parseInt(supply['sort']);
    }
    else {
      supply['sort'] = 1000000;
    }
    
    const loader = this.loadingCtrl.create({});
    loader.present()
    this.database.addSupply(supply).then((res) => {
      loader.dismiss();
      console.log('Supply added');
      this.viewCtrl.dismiss();
    })
    .catch((error) => {
      loader.dismiss();
      console.log("Error adding supply");
    })
  }

  updateSupply() {
    console.log(this.clinic_id);
    console.log(this.supply.value);
    const supply: {} = this.supply.value;
    if(supply['sort']) {
      supply['sort'] = parseInt(supply['sort']);
    }
    else {
      supply['sort'] = 1000000;
    }
    
    const loader = this.loadingCtrl.create({});
    loader.present()
    this.database.updateSupply(supply).then((res) => {
      loader.dismiss();
      this.viewCtrl.dismiss();
    })
    .catch((error) => {
      loader.dismiss();
      console.log("error updating supply");
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/admin-supplies-add/admin-supplies-add.ts